var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHerd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFE137"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4815 14.7565C31.4815 14.7565 29.282 17.8221 27.1594 17.8221C26.3085 17.8539 25.4792 17.5506 24.8497 16.9773C24.2201 16.404 23.8407 15.6066 23.793 14.7565C23.793 12.7138 27.9199 11.5672 31.4815 14.7565Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7007 24.448C21.4396 25.386 20.8785 26.2127 20.1032 26.8017C19.3279 27.3907 18.381 27.7096 17.4073 27.7096C16.4337 27.7096 15.4868 27.3907 14.7115 26.8017C13.9362 26.2127 13.3751 25.386 13.114 24.448L10.5305 15.168C10.3964 14.6897 10.4289 14.1799 10.6228 13.7225C10.8166 13.265 11.1602 12.8871 11.5972 12.6507C13.3608 11.6258 15.3643 11.0859 17.4041 11.0859C19.4439 11.0859 21.4474 11.6258 23.2111 12.6507C23.6482 12.8869 23.9919 13.2649 24.1858 13.7223C24.3796 14.1798 24.4121 14.6897 24.2777 15.168L21.7007 24.448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8057 16.1482C11.0053 15.8396 11.2793 15.5862 11.6025 15.4112C13.3661 14.3863 15.3696 13.8464 17.4094 13.8464C19.4492 13.8464 21.4527 14.3863 23.2164 15.4112C23.539 15.5861 23.8125 15.8392 24.0121 16.1472L24.2862 15.1637C24.5604 14.176 24.1188 12.0512 23.2196 11.5648C21.4559 10.5399 19.4524 10 17.4126 10C15.3728 10 13.3693 10.5399 11.6057 11.5648C10.7054 12.0501 10.2617 14.1781 10.539 15.1637L10.8057 16.1482Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7003 24.4476C21.4392 25.3856 20.8782 26.2123 20.1028 26.8013C19.3275 27.3903 18.3806 27.7092 17.407 27.7092C16.4333 27.7092 15.4865 27.3903 14.7111 26.8013C13.9358 26.2123 13.3747 25.3856 13.1137 24.4476L10.5302 15.1676C10.255 14.182 10.6987 12.054 11.5969 11.5687C13.3605 10.5438 15.364 10.0039 17.4038 10.0039C19.4436 10.0039 21.4471 10.5438 23.2107 11.5687C24.1131 12.0551 24.5558 14.1799 24.2774 15.1676L21.7003 24.4476Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5511 24.5639C14.3307 24.854 14.1956 25.1998 14.1611 25.5625C14.1266 25.9252 14.194 26.2903 14.3558 26.6168C14.5175 26.9432 14.7671 27.2181 15.0766 27.4104C15.386 27.6027 15.743 27.7048 16.1073 27.7052H18.71C19.075 27.7054 19.4329 27.6034 19.743 27.4109C20.0532 27.2184 20.3034 26.943 20.4653 26.6158C20.6271 26.2886 20.6943 25.9227 20.6591 25.5593C20.624 25.196 20.4879 24.8497 20.2663 24.5596L20.2289 24.5116C19.894 24.0845 19.4664 23.7391 18.9783 23.5016C18.4903 23.264 17.9546 23.1406 17.4119 23.1406C16.8691 23.1406 16.3334 23.264 15.8454 23.5016C15.3573 23.7391 14.9297 24.0845 14.5948 24.5116L14.5511 24.5639Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7734 16.3348C13.7734 16.6256 13.889 16.9045 14.0946 17.1102C14.3002 17.3158 14.5792 17.4313 14.87 17.4313C15.1608 17.4313 15.4397 17.3158 15.6453 17.1102C15.851 16.9045 15.9665 16.6256 15.9665 16.3348C15.9665 16.044 15.851 15.7651 15.6453 15.5594C15.4397 15.3538 15.1608 15.2383 14.87 15.2383C14.5792 15.2383 14.3002 15.3538 14.0946 15.5594C13.889 15.7651 13.7734 16.044 13.7734 16.3348Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 16.3348C18.7852 16.6256 18.9007 16.9045 19.1063 17.1102C19.312 17.3158 19.5909 17.4313 19.8817 17.4313C20.1725 17.4313 20.4514 17.3158 20.6571 17.1102C20.8627 16.9045 20.9782 16.6256 20.9782 16.3348C20.9782 16.044 20.8627 15.7651 20.6571 15.5594C20.4514 15.3538 20.1725 15.2383 19.8817 15.2383C19.5909 15.2383 19.312 15.3538 19.1063 15.5594C18.9007 15.7651 18.7852 16.044 18.7852 16.3348Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2734 25.1289V26.0206",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 25.1289V26.0206",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 14.7565C3.33203 14.7565 5.5315 17.8221 7.65417 17.8221C8.50493 17.8536 9.33412 17.5502 9.96358 16.977C10.593 16.4037 10.9725 15.6065 11.0206 14.7565C11.0206 12.7138 6.89363 11.5672 3.33203 14.7565Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerd);
export default __webpack_public_path__ + "static/media/herd.e8085df52e9a3cdf8283e3f84baf09b3.svg";
export { ForwardRef as ReactComponent };